import Vue from 'vue'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'
